import usePagedQuery, { PagedQueryArgs } from '../usePagedQuery';
import UserData from '../../types/IUserResponse';

export default function useUserList(args: PagedQueryArgs) {
  return usePagedQuery<UserData>('user-list', 'api/users', args);
}
